module.exports = __webpack_public_path__ + "static/media/check.616ccc58.svg";